import React, { useEffect, useState } from "react";
import AcademyModal from "../../../components/Settings/academy/modal/AcademyModal";
import useAcademy from "../../../hooks/useAcademy";
import { useSelector } from "react-redux";
import { TrainingCard } from "../../../components/Settings/academy/TrainingCard";
import Loading from "../../../components/animation/loading";

export default function Academy() {
  const [openAcademy, setOpenAcademy] = useState(false);
  const [loading, setLoading] = useState(false);
  const { trainings } = useSelector((state) => state.academySettings);
  const [triggerFetchTraining, setTriggerFetchTraining] = useState(0);
//  get trainings hook
  const { getTrainings } = useAcademy();

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        await getTrainings(setLoading);
      } catch (error) {
        setLoading(false);
      }
      setLoading(false);
    };

    fetchData();
  }, [triggerFetchTraining]);

  return (
    <>
      <div className=" flex flex-col space-y-6">
        <div className="flex justify-between items-center">
          <h2 className="text-2xl">Academy</h2>
          <button
            onClick={() => setOpenAcademy(true)}
            className="bg-theme1 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition"
          >
            New training
          </button>
        </div>
        <hr className="border-b border-gray-200" />
        {loading ? (
          <div className="flex justify-center items-center">
            <Loading />
          </div>
        ) : trainings.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {trainings?.map((training) => (
              <TrainingCard
                triggerFetchTraining={() =>
                  setTriggerFetchTraining((t) => t + 1)
                }
                key={training._id}
                training={training}
              />
            ))}
          </div>
        ) : (
          <div className="flex justify-center">No Traings found</div>
        )}
      </div>
      {openAcademy && (
        <AcademyModal
          onTrigger={() => setTriggerFetchTraining((t) => t + 1)}
          setOpenAcademy={setOpenAcademy}
        />
      )}
    </>
  );
}
